import { render, staticRenderFns } from "./edit-brand.vue?vue&type=template&id=dd8744a2&scoped=true&"
import script from "./edit-brand.vue?vue&type=script&lang=js&"
export * from "./edit-brand.vue?vue&type=script&lang=js&"
import style0 from "./edit-brand.vue?vue&type=style&index=0&id=dd8744a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8744a2",
  null
  
)

export default component.exports